import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const CompCuration = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedSource, setSelectedSource] = useState('');

  const pendingComps = [
  {
    id: 1,
    craneModel: "Liebherr LTM 1200-5.1",
    year: 2020,
    hours: 3450,
    price: 1250000,
    source: "Auction",
    dealer: "Heavy Equipment Solutions",
    location: "Houston, TX",
    dateAdded: "2025-11-06",
    submittedBy: "system@craneprice.com",
    status: "Pending Review",
    confidence: 85,
    images: [
    {
      url: "https://images.unsplash.com/photo-1733067996013-ec5b8eec3f52",
      alt: "Yellow mobile crane with extended boom at construction site"
    }],

    description: `Excellent condition Liebherr mobile crane with recent maintenance records.\nFull service history available.\nNo major repairs or accidents reported.`,
    specifications: {
      capacity: "200 tons",
      boomLength: "72m",
      jibLength: "19m",
      engineHours: 3450,
      condition: "Excellent"
    }
  },
  {
    id: 2,
    craneModel: "Tadano ATF 130G-5",
    year: 2019,
    hours: 5200,
    price: 890000,
    source: "Private Sale",
    dealer: "Crane Masters Inc",
    location: "Atlanta, GA",
    dateAdded: "2025-11-05",
    submittedBy: "admin@craneprice.com",
    status: "Needs Review",
    confidence: 72,
    images: [
    {
      url: "https://images.unsplash.com/photo-1447797729657-a23e2d05d4e6",
      alt: "Red and white mobile crane positioned on construction site with city skyline"
    }],

    description: `Well-maintained Tadano crane with complete service records.\nRecent hydraulic system overhaul completed.\nReady for immediate deployment.`,
    specifications: {
      capacity: "130 tons",
      boomLength: "60m",
      jibLength: "19m",
      engineHours: 5200,
      condition: "Good"
    }
  },
  {
    id: 3,
    craneModel: "Grove GMK5250L",
    year: 2021,
    hours: 1800,
    price: 1450000,
    source: "Dealer",
    dealer: "National Crane Sales",
    location: "Denver, CO",
    dateAdded: "2025-11-04",
    submittedBy: "curator@craneprice.com",
    status: "Quality Check",
    confidence: 91,
    images: [
    {
      url: "https://images.unsplash.com/photo-1678860886480-d0d2a3757597",
      alt: "Large white mobile crane with extended boom at industrial construction site"
    }],

    description: `Nearly new Grove crane with minimal usage hours.\nFactory warranty still active.\nComplete documentation package included.`,
    specifications: {
      capacity: "250 tons",
      boomLength: "70m",
      jibLength: "21m",
      engineHours: 1800,
      condition: "Excellent"
    }
  }];


  const statusOptions = [
  { value: '', label: 'All Status' },
  { value: 'Pending Review', label: 'Pending Review' },
  { value: 'Needs Review', label: 'Needs Review' },
  { value: 'Quality Check', label: 'Quality Check' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Rejected', label: 'Rejected' }];


  const sourceOptions = [
  { value: '', label: 'All Sources' },
  { value: 'Auction', label: 'Auction' },
  { value: 'Private Sale', label: 'Private Sale' },
  { value: 'Dealer', label: 'Dealer' },
  { value: 'Import', label: 'Import' }];


  const filteredComps = pendingComps?.filter((comp) => {
    const matchesSearch = comp?.craneModel?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    comp?.dealer?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    const matchesStatus = !selectedStatus || comp?.status === selectedStatus;
    const matchesSource = !selectedSource || comp?.source === selectedSource;
    return matchesSearch && matchesStatus && matchesSource;
  });

  const handleApprove = (compId) => {
    console.log('Approving comp:', compId);
  };

  const handleReject = (compId) => {
    console.log('Rejecting comp:', compId);
  };

  const handleEdit = (compId) => {
    console.log('Editing comp:', compId);
  };

  const handleViewDetails = (compId) => {
    console.log('Viewing comp details:', compId);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Pending Review':return 'bg-warning/10 text-warning';
      case 'Needs Review':return 'bg-error/10 text-error';
      case 'Quality Check':return 'bg-accent/10 text-accent';
      case 'Approved':return 'bg-success/10 text-success';
      case 'Rejected':return 'bg-muted text-text-secondary';
      default:return 'bg-muted text-text-secondary';
    }
  };

  const getConfidenceColor = (confidence) => {
    if (confidence >= 80) return 'text-success';
    if (confidence >= 60) return 'text-warning';
    return 'text-error';
  };

  return (
    <div className="space-y-6">
      {/* Header Actions */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex flex-col sm:flex-row gap-3 flex-1">
          <div className="flex-1">
            <Input
              type="search"
              placeholder="Search by crane model or dealer..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e?.target?.value)}
              className="w-full" />

          </div>
          <div className="w-full sm:w-40">
            <Select
              options={statusOptions}
              value={selectedStatus}
              onChange={setSelectedStatus}
              placeholder="Filter by status" />

          </div>
          <div className="w-full sm:w-40">
            <Select
              options={sourceOptions}
              value={selectedSource}
              onChange={setSelectedSource}
              placeholder="Filter by source" />

          </div>
        </div>
        
        <div className="flex flex-wrap gap-2">
          <Button
            variant="outline"
            onClick={() => console.log('Bulk approve')}
            iconName="CheckCircle"
            iconPosition="left"
            size="sm">

            Bulk Approve
          </Button>
          <Button
            variant="outline"
            onClick={() => console.log('Export comps')}
            iconName="Download"
            iconPosition="left"
            size="sm">

            Export
          </Button>
        </div>
      </div>
      {/* Statistics Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-warning/10 rounded-lg flex items-center justify-center">
              <Icon name="Clock" size={20} className="text-warning" />
            </div>
            <div>
              <p className="text-sm text-text-secondary">Pending Review</p>
              <p className="text-2xl font-semibold text-text-primary">127</p>
            </div>
          </div>
        </div>
        
        <div className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
              <Icon name="CheckCircle" size={20} className="text-success" />
            </div>
            <div>
              <p className="text-sm text-text-secondary">Approved Today</p>
              <p className="text-2xl font-semibold text-text-primary">23</p>
            </div>
          </div>
        </div>
        
        <div className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-error/10 rounded-lg flex items-center justify-center">
              <Icon name="XCircle" size={20} className="text-error" />
            </div>
            <div>
              <p className="text-sm text-text-secondary">Rejected</p>
              <p className="text-2xl font-semibold text-text-primary">8</p>
            </div>
          </div>
        </div>
        
        <div className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
              <Icon name="TrendingUp" size={20} className="text-accent" />
            </div>
            <div>
              <p className="text-sm text-text-secondary">Avg Confidence</p>
              <p className="text-2xl font-semibold text-text-primary">82%</p>
            </div>
          </div>
        </div>
      </div>
      {/* Comps Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        {filteredComps?.map((comp) =>
        <div key={comp?.id} className="bg-card border border-border rounded-lg overflow-hidden">
            {/* Image */}
            <div className="relative h-48 overflow-hidden">
              <img
              src={comp?.images?.[0]?.url}
              alt={comp?.images?.[0]?.alt}
              className="w-full h-full object-cover" />

              <div className="absolute top-3 right-3">
                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(comp?.status)}`}>
                  {comp?.status}
                </span>
              </div>
              <div className="absolute top-3 left-3">
                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-background/90 ${getConfidenceColor(comp?.confidence)}`}>
                  {comp?.confidence}% confidence
                </span>
              </div>
            </div>

            {/* Content */}
            <div className="p-4 space-y-4">
              {/* Header */}
              <div>
                <h3 className="font-semibold text-text-primary">{comp?.craneModel}</h3>
                <p className="text-sm text-text-secondary">{comp?.year} • {comp?.hours?.toLocaleString()} hours</p>
              </div>

              {/* Price and Details */}
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-text-secondary">Price:</span>
                  <span className="font-semibold text-text-primary">${comp?.price?.toLocaleString()}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-text-secondary">Source:</span>
                  <span className="text-sm text-text-primary">{comp?.source}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-text-secondary">Location:</span>
                  <span className="text-sm text-text-primary">{comp?.location}</span>
                </div>
              </div>

              {/* Dealer */}
              <div className="pt-2 border-t border-border">
                <p className="text-sm text-text-secondary">Dealer:</p>
                <p className="font-medium text-text-primary">{comp?.dealer}</p>
              </div>

              {/* Description Preview */}
              <div className="pt-2 border-t border-border">
                <p className="text-sm text-text-secondary line-clamp-2">
                  {comp?.description?.split('\n')?.[0]}
                </p>
              </div>

              {/* Actions */}
              <div className="flex items-center justify-between pt-2 border-t border-border">
                <div className="flex items-center space-x-2">
                  <Button
                  variant="default"
                  size="sm"
                  onClick={() => handleApprove(comp?.id)}
                  iconName="Check" />

                  <Button
                  variant="destructive"
                  size="sm"
                  onClick={() => handleReject(comp?.id)}
                  iconName="X" />

                </div>
                <div className="flex items-center space-x-2">
                  <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => handleEdit(comp?.id)}
                  iconName="Edit" />

                  <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => handleViewDetails(comp?.id)}
                  iconName="Eye" />

                </div>
              </div>

              {/* Metadata */}
              <div className="text-xs text-text-secondary pt-2 border-t border-border">
                <p>Added: {comp?.dateAdded}</p>
                <p>By: {comp?.submittedBy}</p>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Pagination */}
      <div className="flex items-center justify-between">
        <p className="text-sm text-text-secondary">
          Showing {filteredComps?.length} of 127 pending comparables
        </p>
        <div className="flex items-center space-x-2">
          <Button variant="outline" size="sm" iconName="ChevronLeft">
            Previous
          </Button>
          <Button variant="outline" size="sm">1</Button>
          <Button variant="default" size="sm">2</Button>
          <Button variant="outline" size="sm">3</Button>
          <Button variant="outline" size="sm" iconName="ChevronRight">
            Next
          </Button>
        </div>
      </div>
    </div>);

};

export default CompCuration;